import React from 'react'

function QuestionOne({label, value, setValue}) {
  return (
    <div className='w-full flex justify-start p-[1.3vmax] items-center'>
    <form>
            <div>
            <label className='text-black text-[1.3vmax] font-semibold'>{label}:</label></div>
            <select onChange={(e)=>{
              setValue(e.target.value);
            }} className='rounded-[0.2vmax] text-[1.1vmax] w-[20vmax] h-[2vmax] px-[0.5vmax]'>
                <option>Select</option>
                <option>Mostly Tidy</option>
                <option>Somewhat Clean</option>
                <option>Messy</option>
            </select>
        </form>
    </div>
  )
}

export default QuestionOne